
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
	name: 'TransferDirectionBtn',
	props: {
		isToCompany: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
	},
	computed: {
		...mapGetters([
			'displayLabels',
		]),
	},
	methods: {
		onChangeDirection() {
			if (this.disabled) return;
			this.$emit('is-to-company-change', !this.isToCompany);
		},
	},
});
